import React, { useState } from 'react';
import theme from '@theme';

import ProgressBar from '@components/ContributionCard/ProgressBar';
import {
  Carousel,
  CarouselContainer,
  CarouselControl,
  CarouselControls,
  CarouselOuterWrapper
} from './styles';

const GridCarousel = ({
  onScreenCount, children, homePage, paddingTop, HideArrow,
  pagination, length, contributionCard, blogs
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [intervalId, setIntervalId] = React.useState(null);
  const color = theme.colors.darkTeal;

  const handleTimeInterval = () => {
    clearInterval(intervalId);
    const newId = setInterval(() => {
      setCurrentIndex((x) => {
        if (x > length - 1) {
          return 0;
        }
        return x + 1;
      });
    }, 4000);

    setIntervalId(newId);
  };

  return (
    <CarouselOuterWrapper pagination={pagination}>
      <CarouselContainer paddingTop={paddingTop}>
        <Carousel
          moveValue={100 / Math.ceil(length / onScreenCount)}
          currentIndex={currentIndex}
          totalChild={length}
          onScreenCount={onScreenCount}
        >
          {children}
        </Carousel>
      </CarouselContainer>
      <CarouselControls HideArrow={HideArrow} pagination={pagination} blogs={blogs}>
        <CarouselControl
          hide={currentIndex === 0}
          onClick={() => {
            setCurrentIndex(Math.max(currentIndex - 1, 0));
          }}
          className="carousel-control-prev"
          pagination={pagination}
        >
          <img src={pagination ? '/static/images/svg/new-chevron-right.svg' : '/svg/packageScreen/prev-arrow.svg'} alt="arrrow" />
        </CarouselControl>
        {pagination ? (
          <ProgressBar
            slide={currentIndex}
            setSlide={setCurrentIndex}
            intervalId={intervalId}
            clickable
            color={color}
            handleTimeInterval={handleTimeInterval}
            pagination={pagination}
            length={Math.ceil(length / onScreenCount)}
            homePage={homePage}
            contributionCard={contributionCard}
          />
        ) : <></>}
        <CarouselControl
          hide={currentIndex + 1 === Math.ceil(length / onScreenCount)}
          onClick={() => {
            setCurrentIndex(Math.min(currentIndex + 1, Math.ceil(length / onScreenCount) - 1));
          }}
          className="carousel-control-next"
          pagination={pagination}
        >
          <img src={pagination ? '/static/images/svg/new-chevron-left.svg' : '/svg/packageScreen/next.svg'} alt="arrrow" />
        </CarouselControl>
      </CarouselControls>
    </CarouselOuterWrapper>
  );
};

export default GridCarousel;
